import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addConditions: {
    id: `app.containers.WorkflowEditor.components.Rules.DocumentSigningRules.DocumentSigningRuleCard.addConditions`,
    defaultMessage: 'Add conditions',
  },
  documentSet: {
    id: `app.containers.WorkflowEditor.components.Rules.DocumentSigningRules.DocumentSigningRuleCard.documentSet`,
    defaultMessage: 'Document Set {number}',
  },
  dragRule: {
    id: `app.containers.WorkflowEditor.components.Rules.DocumentSigningRules.DocumentSigningRuleCard.dragRule`,
    defaultMessage: 'Drag document set {number}',
    description: 'Accessible label for the document set drag handle',
  },
});
